import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders  } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Location } from "./location.model";

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  selectedLocation: Location;
  LocationList: Location[];

  constructor(private httpClient: HttpClient) { }
  
  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDLocation(location: Location) {

    let body = location;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/LocationDetails/IUD', body,{headers: headers});
  }

  FetchLocationByLocationId(location) {
    
    let body = location;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/LocationDetails/Fetch', body,{headers: headers});
  }

  GetLocation(){

    let body = location;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Location', body,{headers: headers});
 
    // var body = JSON.stringify('');
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post( this.getBaseUrl() +  'api/CommonMaster/Location', body, requestOptions).map(x => x.json());
  }

  //-----------------------------FetchLocationList----Component-------------------------------------
  FetchLocationList() {
    
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/LocationDetails/FetchList', body,{headers: headers});
 
    // var body = JSON.stringify('');
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/LocationDetails/FetchList', body, requestOptions).map(x => x.json());
  }
}
